import React from "react";
import Email from "../images/Email.svg";
import Password from "../images/Password.svg";
import { useMediaQuery } from "react-responsive";

export default function Input({
  type = "text",
  step = "",
  placeholder,
  required = false,
  value,
  setValue,
  label = "",
  error = null,
  viewMode,
  pattern,
  number = false,
  disabled = false,
  autoFocus = false,
  ref = null,
  maxLength=30,
}) {
  const isSmallScreen = useMediaQuery({ maxWidth: 648 });
  const onPress = (e) => {
    const re = /^[0-9\b]+$/;

    if (number === true) {
      if (e.target.value === "" || re.test(e.target.value)) {
        return true;
      } else return false;
    }
  };
  const onChange = (e) => {
    const re = /^[0-9\b]+$/;

    if (number === true) {
      if (e.target.value === "" || re.test(e.target.value)) {
        setValue(e.target.value);
      }
    } else {
      setValue(e.target.value);
    }
  };

  return (
    <div className="relative pb-5">
      {viewMode && type === "password" ? (
        <input
          autoFocus={autoFocus}
          disabled={true}
          className="bg-white"
          type={"password"}
          value={"sampletext"}
          required={false}
        />
      ) : (
        <>
          <div className="flex flex-row items-center justify-between">
            {label ? <label htmlFor="error">{label}</label> : null}
            {error && !isSmallScreen ? (
              <p className="error-text">{error}</p>
            ) : null}
          </div>
          <input
            id="error"
            step={step}
            disabled={viewMode}
            ref={ref}
            type={type}
            pattern={pattern}
            value={value}
            class={`
            ${
              viewMode
                ? "border-transparent focus:border-transparent"
                : " border border-gray-300 bg-white text-gray-600 focus:border-blue-500"
            } 
            text-input bg-transparent valid:bg-white py-[7.2px]
            ${error ? "border-red-500" : ""}`}
            placeholder={viewMode ? "" : placeholder}
            required={required}
            onChange={viewMode ? () => {} : onChange}
            onKeyDown={onPress}
            maxLength={maxLength}
          />
        </>
      )}
    </div>
  );
}
